import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { container } from "setup/dependency/inversify.config";
import { IAuthUsersService } from "services/AuthUsersService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { RootState } from "setup";
import * as auth from "app/modules/auth";
import { toast } from "react-toastify";

const initialState = {
  ResetPasswordResponse: false,
  RedirectToDashboard: false,
  updatingPassword: false,
};

export const passwordChangeSlice = createSlice({
  name: "passwordChange",
  initialState,
  reducers: {
    setRedirectToDashboard: (state, action) => {
      state.RedirectToDashboard = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updatePassword.pending, (state) => {
        state.updatingPassword = true;
      })
      .addCase(updatePassword.rejected, (state) => {
        state.updatingPassword = false;
      })
      .addCase(updatePassword.fulfilled, (state) => {
        toast.success("Password changed");
        state.ResetPasswordResponse = true;
        state.updatingPassword = false;
      });
  },
});

export const updatePassword = createAsyncThunk<void, { newPassword: string; userID?: string }, { state: RootState }>(
  "passwordChange/updatePassword",
  async ({ newPassword, userID }: { newPassword: string; userID?: string }, thunkAPI) => {
    const state = thunkAPI.getState();
    const currentUser = state.auth.user?.userID;
    const usersService = container.get<IAuthUsersService>(SERVICE_TYPES.AuthUsersService);
    if (userID === currentUser || userID === undefined || userID === null) {
      await usersService.changeProfilePassword(newPassword);
    } else {
      await usersService.changePassword(userID, newPassword);
    }

    thunkAPI.dispatch(auth.actions.requestUser);
  }
);

export const { setRedirectToDashboard } = passwordChangeSlice.actions;

export const selectRedirectToDashboard = (state: RootState) => {
  return state.passwordChange.RedirectToDashboard;
};
export const selectResetPasswordResponse = (state: RootState) => {
  return state.passwordChange.ResetPasswordResponse;
};
export const selectUpdatingPassword = (state: RootState) => {
  return state.passwordChange.updatingPassword;
};

export default passwordChangeSlice.reducer;
